// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dT1rzcvAFCNu849ak95kR","groupsList":"_37evGZHPkOo39nWC_ssnFq"};